import { BreadcrumbsManager } from "./BreadcrumbsManager.js";

BreadcrumbsManager.use();
